export default "__VITE_ASSET__DPhuxC81__"